module.exports = __webpack_public_path__ + "img/violet-1.22164c76.png";